<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-body">
        <!-- Thông tin cơ bản -->
        <div class="row">
          <div class="col-md-4 ">
            <div class="d-flex align-items-end justify-content-between">
              <div class="w-75">
                <label class="form-label">Số thuê bao</label>
                <input type="text" class="form-control" v-model="searchPhone">
              </div>
              <button @click="getCorporateSubscriberInfo" class="btn btn-primary p-1">Tra cứu</button>
            </div>
          </div>
          <div class="col-md-4 ">
            <label class="form-label">Tên Doanh nghiệp</label>
            <input type="text" class="form-control" :value="numberInfo.NAME" readonly>
          </div>
          <div class="col-md-4 ">
            <label class="form-label">Số giấy chứng nhận pháp nhân</label>
            <input type="text" class="form-control" :value="numberInfo.KHDN_ID" readonly>
          </div>
        </div>

        <!-- Thông tin người đại diện -->
        <h5 class="mt-2">Thông tin người đại diện</h5>
        <div class="row">
          <div class="col-md-4 mb-1">
            <label class="form-label">Họ và tên người đại diện</label>
            <input type="text" class="form-control" style="line-height: 3" :value="numberInfo.req_info.fullname"
                   readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Ngày sinh</label>
            <input type="text" class="form-control" :value="numberInfo.req_info.birthday" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Số giấy tờ tùy thân</label>
            <input type="text" class="form-control" :value="numberInfo.req_info.idnumber" readonly>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 mb-1">
            <label class="form-label">Loại giấy tờ</label>
            <input type="text" class="form-control" :value="numberInfo.req_info.loaigt" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Ngày cấp</label>
            <input type="text" class="form-control" :value="numberInfo.req_info.placedate" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Nơi cấp</label>
            <input type="text" class="form-control" :value="numberInfo.req_info.noicap" readonly>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-1">
            <label class="form-label">Địa chỉ thường trú</label>
            <input type="text" class="form-control" :value="numberInfo.req_info.address" readonly>
          </div>
          <div class="col-md-3 mb-1">
            <label class="form-label">Giới tính</label>
            <input type="text" class="form-control" :value="numberInfo.req_info.gender === 'male' ? 'Nam' : 'Nữ'"
                   readonly>
          </div>
          <div class="col-md-3 mb-1">
            <label class="form-label">Quốc tịch</label>
            <input type="text" class="form-control" :value="numberInfo.req_info.nationalityid" readonly>
          </div>
        </div>

        <!-- Thông tin ủy quyền -->
        <h5 class="mt-2 mb-1">Thông tin ủy quyền</h5>
        <div class="row">
          <div class="col-md-6 mb-1">
            <label class="form-label">Số giấy ủy quyền</label>
            <input type="text" class="form-control" :value="numberInfo.UQ_NUMBER" readonly>
          </div>
          <div class="col-md-6 mb-1">
            <label class="form-label">Ngày cấp giấy ủy quyền</label>
            <input type="text" class="form-control" :value="numberInfo.UQ_DATE" readonly>
          </div>
        </div>

        <!-- Thông tin đăng ký -->
        <h5 class="mt-2 mb-1">Thông tin đăng ký</h5>
        <div class="row">
          <div class="col-md-4 mb-1">
            <label class="form-label">User đăng ký</label>
            <input type="text" class="form-control" :value="numberInfo.userDktt.username" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Ngày đăng ký</label>
            <input type="text" class="form-control" :value="formatDateTime(numberInfo.userDktt.log_date)" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Loại khách hàng</label>
            <input type="text" class="form-control" :value="numberInfo.CUSTOME_TYPE" readonly>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 mb-1">
            <label class="form-label">Tên GDV</label>
            <input type="text" class="form-control" style="line-height: 3" :value="numberInfo.userDktt.full_name" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Số điện thoại GDV</label>
            <input type="text" class="form-control" :value="numberInfo.userDktt.phone" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Địa chỉ user đăng ký</label>
            <input type="text" class="form-control" :value="numberInfo.userDktt.store_address" readonly>
          </div>
        </div>

        <!-- Thông tin cập nhật -->
        <h5 class="mt-2 mb-1" v-if="numberInfo.userUpdate">Thông tin cập nhật</h5>
        <div class="row" v-if="numberInfo.userUpdate">
          <div class="col-md-4 mb-1">
            <label class="form-label">User cập nhật</label>
            <input type="text" class="form-control" :value="numberInfo.userUpdate.username" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Ngày cập nhật</label>
            <input type="text" class="form-control" :value="formatDateTime(numberInfo.userUpdate.log_date)" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Loại khách hàng</label>
            <input type="text" class="form-control" :value="numberInfo.CUSTOME_TYPE" readonly>
          </div>
        </div>
        <div class="row" v-if="numberInfo.userUpdate">
          <div class="col-md-4 mb-1">
            <label class="form-label">Tên GDV</label>
            <input type="text" class="form-control" :value="numberInfo.userUpdate.full_name" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Số điện thoại GDV</label>
            <input type="text" class="form-control" :value="numberInfo.userUpdate.phone" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Địa chỉ user cập nhật</label>
            <input type="text" class="form-control" style="line-height: 3" :value="numberInfo.userUpdate.store_address" readonly>
          </div>
        </div>

        <!-- Thông tin gói cước -->
        <h5 class="mt-2 mb-1">Thông tin gói cước</h5>
        <div class="row">
          <div class="col-md-4 mb-1">
            <label class="form-label">Gói cước đang sử dụng</label>
            <input type="text" class="form-control" :value="numberInfo.PACKAGE" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Ngày đăng ký gói</label>
            <input type="text" class="form-control" :value="numberInfo.PKG_START" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Ngày hết hạn gói</label>
            <input type="text" class="form-control" :value="numberInfo.PKG_END" readonly>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 mb-1">
            <label class="form-label">Tài khoản chính</label>
            <input type="text" class="form-control" :value="numberInfo.BALANCE" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Trạng thái phê duyệt</label>
            <input type="text" class="form-control" :value="getApproveStatusText(numberInfo.APPROVE_STATUS)" readonly>
          </div>
          <div class="col-md-4 mb-1">
            <label class="form-label">Mã hợp đồng ĐKTTTB</label>
            <input type="text" class="form-control" :value="numberInfo.HD_ID_DKTT" readonly>
          </div>
        </div>

        <!-- Trạng thái SMT/SMO -->
        <div class="row">
          <div class="col-md-6 mb-1">
            <label class="form-label">Trạng thái SMT/SMO</label>
            <div class=" d-flex align-items-center">
              <div class=" mr-4">
                <input class="pl-0" type="checkbox" :checked="numberInfo.ic === 'A'" disabled>
                <label class="form-check-label">SMT</label>
              </div>
              <div class="">
                <input class="" type="checkbox" :checked="numberInfo.oc === 'A'" disabled>
                <label class="form-check-label">SMO</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-1">
            <label class="form-label"></label>
            <div class=" d-flex align-items-center">
              <div class=" mr-4">
                <button class="btn btn-primary"
                        @click="viewVideo(numberInfo.req_info.idnumber,searchPhone.startsWith('84')?searchPhone.replace('84','0'):searchPhone,numberInfo.REGISTER_DATE)">
                  Xem video
                </button>
              </div>
              <div class="">
                <button class="btn btn-primary"
                        @click="viewC06History(numberInfo.req_info.idnumber,searchPhone.startsWith('84')?searchPhone.replace('84','0'):searchPhone,numberInfo.REGISTER_DATE)">
                  Xem lịch sử C06
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Danh sách ảnh hồ sơ -->
        <h5 class="mt-2 mb-1">Danh sách ảnh hồ sơ</h5>
        <div class="row">
          <div class="col-md-4 mb-1">
            <div class="card">
              <div class="card-body text-center">
                <img v-if="numberInfo.IMG1" :src="numberInfo.IMG1" class="img-fluid mb-2"
                     alt="Ảnh mặt trước">
                <div v-else class="text-muted py-4">Không có ảnh</div>
                <p class="card-text">Ảnh mặt trước</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-1">
            <div class="card">
              <div class="card-body text-center">
                <img v-if="numberInfo.IMG2" :src="numberInfo.IMG2" class="img-fluid mb-2"
                     alt="Ảnh mặt sau">
                <div v-else class="text-muted py-4">Không có ảnh</div>
                <p class="card-text">Ảnh mặt sau</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-1">
            <div class="card">
              <div class="card-body text-center">
                <img v-if="numberInfo.IMG3" :src="numberInfo.IMG3" class="img-fluid mb-2"
                     alt="Ảnh chân dung">
                <div v-else class="text-muted py-4">Không có ảnh</div>
                <p class="card-text">Ảnh chân dung</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Các ảnh tài liệu -->
        <div class="row">
          <div class="col-md-4 mb-1">
            <div class="card">
              <div class="card-body text-center">
                <button v-if="numberInfo.HD_IMG" class="btn btn-primary"
                        @click="openImageModal(numberInfo.HD_IMG, 'Hợp đồng/phụ lục')">
                  Xem Ảnh Hợp đồng/phụ lục
                </button>
                <div v-else class="text-muted">Không có ảnh hợp đồng</div>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-1">
            <div class="card">
              <div class="card-body text-center">
                <button v-if="numberInfo.PN_IMG" class="btn btn-primary"
                        @click="openImageModal(numberInfo.PN_IMG, 'Chứng nhận pháp nhân')">
                  Xem Ảnh Chứng nhận pháp nhân
                </button>
                <div v-else class="text-muted">Không có ảnh chứng nhận</div>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-1">
            <div class="card">
              <div class="card-body text-center">
                <button v-if="numberInfo.UQ_IMG" class="btn btn-primary"
                        @click="openImageModal(numberInfo.UQ_IMG, 'Giấy ủy quyền')">
                  Xem Ảnh Giấy ủy quyền
                </button>
                <div v-else class="text-muted">Không có ảnh ủy quyền</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal hiển thị ảnh -->
    <b-modal class="modal fade" id="imageModal" hide-footer size="xl" :title="modalInfo.title">
      <div class="modal-body text-center">
        <iframe :src="modalInfo.src" class="w-100" style="height: 80vh;"></iframe>
      </div>
    </b-modal>
    <b-modal
        v-model="showVideoModal"
        :title="'Video'"
        size="xl"
        hide-footer
        @hidden="showVideoModal=false"
    >
      <div v-if="videoUrl" class="text-center">
        <video
            ref="videoPlayer"
            :src="videoUrl"
            class="w-100"
            controls
            style="max-height: 70vh"
        ></video>
      </div>
    </b-modal>
    <b-modal
        v-model="showC06HisModal"
        title="Lịch sử kiểm tra c06"
        size="xl"
        hide-footer
        @hidden="showC06HisModal=false"
    >
      <div class="table-responsive">
        <table class="table table-striped table-bordered">
          <thead class="thead-primary">
          <tr>
            <th style="min-width: 60px;">STT</th>
            <th style="min-width: 80px;">ID</th>
            <th style="min-width: 150px;">Số CCCD</th>
            <th style="min-width: 120px;">Ngày sinh</th>
            <th style="min-width: 180px;">Họ tên đầy đủ</th>
            <th style="min-width: 100px;">KQ CCCD</th>
            <th style="min-width: 100px;">KQ Ngày sinh</th>
            <th style="min-width: 100px;">KQ Tên</th>
            <th style="min-width: 150px;">Thời gian kiểm tra</th>
          </tr>
          </thead>
          <tbody v-if="c06Info && c06Info.detail">
          <tr v-for="(item, index) in c06Info.detail" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>{{ item.id }}</td>
            <td>{{ item.idnumber || 'N/A' }}</td>
            <td>{{ formatDob(item.dob) || 'N/A' }}</td>
            <td>{{ item.name || 'N/A' }}</td>
            <td class="text-center">
              <feather-icon v-if="item.idnumber_result === 'true'" icon="CheckIcon" size="18" class="text-success"/>
              <feather-icon v-else-if="item.idnumber_result === 'false'" icon="XIcon" size="18" class="text-danger"/>
              <span v-else class="text-muted">N/A</span></td>
            <td class="text-center">
              <feather-icon v-if="item.dob_result === 'true'" icon="CheckIcon" size="18" class="text-success"/>
              <feather-icon v-else-if="item.dob_result === 'false'" icon="XIcon" size="18" class="text-danger"/>
              <span v-else class="text-muted">N/A</span></td>
            <td class="text-center">
              <feather-icon v-if="item.name_result === 'true'" icon="CheckIcon" size="18" class="text-success"/>
              <feather-icon v-else-if="item.name_result === 'false'" icon="XIcon" size="18" class="text-danger"/>
              <span v-else class="text-muted">N/A</span></td>
            <td>{{ formatDateTime(item.log_date) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>
<script>import axios from "axios";
import moment from "moment";
import {$ctx} from "@themeConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {BModal} from "bootstrap-vue";

export default {
  components: {BModal}, data() {
    return {
      prevRoute: {},
      videoUrl: "",
      showVideoModal: false,
      showC06HisModal: false,
      c06Info: {},
      getPrefixImgLink: "https://hn.ss.bfcplatform.vn/pos/",
      numberInfo: {
        PHONE: "",
        NAME: "",
        KHDN_ID: "",
        req_info: {
          fullname: '',
          birthday: '',
          idnumber: '',
          loaigt: '',
          placedate: '',
          noicap: '',
          address: '',
          gender: '',
          nationalityid: '',
          img1: '',
          img2: '',
          img3: '',
        },
        UQ_NUMBER: '',
        UQ_DATE: '',
        HD_ID_DKTT: '',
        REGISTER_DATE: "",
        CUSTOME_TYPE: '',
        BALANCE: '',
        APPROVE_STATUS: '',
        PACKAGE: '',
        PKG_START: '',
        PKG_END: '',
        HD_IMG: '',
        PN_IMG: '',
        UQ_IMG: '',
        ic: '',
        oc: '',
        username: '',
        full_name: '',
        phone_GDV: '',
        store_address: '',
        userUpdate:{},
        userDktt:{},
      },
      customerType: {DN_M2M: "Khách hàng M2M", DN_H2H: "Khách hàng du lịch"},
      modalInfo: {src: '', title: ''},
      issuePlaceList: [{
        ISSUED_PLACE_CODE: "CXN",
        ISSUED_PLACE_NAME: "Cục quản lý xuất nhập cảnh",
      }, {
        ISSUED_PLACE_CODE: "CDD",
        ISSUED_PLACE_NAME: "Cục Trưởng Cục Cảnh sát ĐKQL cư trú và DLQG về dân cư",
      }, {
        ISSUED_PLACE_CODE: "CQH",
        ISSUED_PLACE_NAME: "Cục Trưởng Cục Cảnh sát Quản lý hành chính về trật tự xã hội",
      }, {ISSUED_PLACE_CODE: "BCA", ISSUED_PLACE_NAME: "BỘ CÔNG AN",}]
    }
  },
  mounted() {
    if (this.searchPhone && this.searchPhone.length > 0) this.getCorporateSubscriberInfo();
    if (localStorage.getItem('phoneNumberSearch') && this.prevRoute.name === "subscriber-info-page") {
      this.searchPhone = "0" + localStorage.getItem('phoneNumberSearch')
      this.getCorporateSubscriberInfo();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.prevRoute = from)
  },
  methods: {
    viewVideo(idNumber, msisdn, time) {
      if (!idNumber || !msisdn || !time) {
        this.$toast({
          component: ToastificationContent,
          props: {title: "Thiếu thông tin để tải video", icon: "AlertTriangleIcon", variant: "warning"}
        });
        return;
      }
      this.videoUrl = "";
      const formatTime = moment(time, "DD/MM/YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm:ss")
      this.loading(true)
      axios.get(`${$ctx.API_URL}video/${idNumber}/${msisdn}/${formatTime}`, {
        headers: {
          'apikey': localStorage.getItem('accessToken'),
          'Content-Type': 'application/json'
        }
      }).then(response => {
        this.loading(false)
        if (response.data && response.data.code === 200 && response.data.result) {/* API trả về result là string URL trực tiếp */
          this.videoUrl = response.data.result;
          this.showVideoModal = true;
        } else this.$toast({
          component: ToastificationContent,
          props: {
            title: response.data?.message || "Không tìm thấy video",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
      }).catch(error => {
        this.loading(false)
        console.error("Video API error:", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.response?.data?.message || "Không thể tải video",
            icon: "AlertTriangleIcon",
            variant: "error"
          }
        });
      });
    },
    viewC06History(idNumber, msisdn, modifyDate) {
      if (!idNumber || !msisdn || !modifyDate) {
        this.$toast({
          component: ToastificationContent,
          props: {title: "Thiếu thông tin để tải ảnh", icon: "AlertTriangleIcon", variant: "warning"}
        });
        return;
      }/* Format modifyDate từ "DD/MM/YYYY HH:mm:ss" thành "YYYY-MM-DD" */
      let formattedDate = modifyDate;
      try {/* Nếu modifyDate có format DD/MM/YYYY HH:mm:ss */
        if (modifyDate.includes('/')) {
          const datePart = modifyDate.split(' ')[0]; /* Lấy phần date */
          const [day, month, year] = datePart.split('/');
          formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
      } catch (e) {
        console.warn("Error formatting date:", e);
      }
      this.c06Info = null;
      this.loading(true)/* Gọi API C06 để lấy thông tin chi tiết */
      axios.get(`${$ctx.API_URL}c06/${idNumber}/${msisdn}/${formattedDate}/1`, {
        headers: {
          'apikey': localStorage.getItem('accessToken'),
          'Content-Type': 'application/json'
        }
      }).then(response => {
        this.loading(false)
        this.c06Loading = false;
        if (response.data && response.data.code === 200 && response.data.result) {
          this.c06Info = response.data.result;
          this.showC06HisModal = true
        } else {
          console.warn("C06 API warning:", response.data?.message || "Không lấy được thông tin C06");
          this.c06Info = null;
        }
      }).catch(error => {
        this.loading(false)
        this.c06Loading = false;
        console.error("C06 API error:", error);
        this.c06Info = null;
      });
    },
    formatDob(dobString) {
      if (!dobString || dobString.length !== 8) return dobString;/* Format từ "19760617" thành "17/06/1976" */
      const year = dobString.substring(0, 4);
      const month = dobString.substring(4, 6);
      const day = dobString.substring(6, 8);
      return `${day}/${month}/${year}`;
    },
    formatDateTime(dateString) {
      if (!dateString) return '';
      try {
        return moment(dateString).format("DD/MM/YYYY HH:mm:ss");
      } catch (e) {
        return dateString;
      }
    },
    async getCorporateSubscriberInfo() {
      this.loading(true);
      try {
        const response = await axios.post($ctx.API_URL.includes("dev") ? 'https://pos.itel.dev/api/pos/khdn/get_phone_khdn_crm' : "https://pos.itel.vn/api/pos/khdn/get_phone_khdn_crm", {
          type: 1,
          phone: this.searchPhone.startsWith("84") ? this.searchPhone.replace("84", "0") : this.searchPhone,
          KHDN_ID: "",
          columnFilters: {},
          sort: [],
          page: 1,
          pageSize: 50
        });
        if (!response.data.result || response.data.result.length <= 0) {
          this.$toast({
            component: ToastificationContent,
            props: {title: "Không tìm thấy thông tin khách hàng", icon: "AlertTriangleIcon", variant: "danger"}
          });
          return;
        }
        if (response.data.result && response.data.result.length > 0) {
          this.numberInfo = response.data.result[0];/* Xử lý ảnh */
          this.numberInfo.IMG1 = "data:image/png;base64," + this.numberInfo.IMG1;
          this.numberInfo.IMG2 = "data:image/png;base64," + this.numberInfo.IMG2;
          this.numberInfo.IMG3 = "data:image/png;base64," + this.numberInfo.IMG3;
          this.numberInfo.HD_IMG = this.numberInfo.HD_IMG ? this.getPrefixImgLink + this.numberInfo.HD_IMG : "";
          this.numberInfo.PN_IMG = this.numberInfo.PN_IMG ? this.getPrefixImgLink + this.numberInfo.PN_IMG : "";
          this.numberInfo.UQ_IMG = this.numberInfo.UQ_IMG ? this.getPrefixImgLink + this.numberInfo.UQ_IMG : "";/* Xử lý loại giấy tờ */
          this.numberInfo.req_info.loaigt = this.numberInfo.req_info.loaigt === '1' ? 'Chứng minh thư' : 'Căn cước công dân';
          this.numberInfo.req_info.nationalityid = "Việt Nam";
          this.numberInfo.req_info.noicap = this.issuePlaceList.find(item => item.ISSUED_PLACE_CODE === this.numberInfo.req_info.noicap)?.ISSUED_PLACE_NAME/* Xử lý loại khách hàng */
          this.numberInfo.CUSTOME_TYPE = this.customerType[this.numberInfo.CUSTOME_TYPE]/* Xử lý ngày tháng */
          this.numberInfo.INSERT_DATE = this.numberInfo.INSERT_DATE ? moment(this.numberInfo.INSERT_DATE).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.response.data.message || "Không tìm thấy thông tin khách hàng",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
        console.error('Lỗi khi lấy thông tin thuê bao:', error.response);
      } finally {
        this.loading(false);
      }
    },
    getApproveStatusText(status) {
      const statusMap = {0: 'Chờ phê duyệt', 1: 'Đã phê duyệt', 2: 'Từ chối'};
      return statusMap[status] || 'Không xác định';
    },
    openImageModal(src, title) {
      this.modalInfo.src = src;
      this.modalInfo.title = title;
      this.$bvModal.show('imageModal');
    }
  },
  props: {
    searchPhone: {
      type: String,
      default: ''
    }
  },
}
</script>
<style scoped>.form-label {
  color: #1e1e1e;
}

.form-control[readonly] {
  background-color: #ffffff;
  color: #1e1e1e;
}

.form-check-input[disabled] {
  background: #ff0000;
  color: #ff0000;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

img {
  max-height: 600px;
  object-fit: cover;
}</style>
